
import { useNavigate } from 'react-router-dom';

import '../styles/EmployeeMaster.css';
import DesignationTable from '../components/DesignationTable';

const Designation = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    
    navigate('/designation/add');
  };

  

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Designation Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Designation
        </button>
      </div>

      <DesignationTable />
    </div>
  );
};

export default Designation;